import { cn } from '@/lib/cn'

/**
 * Four animated vertical bars indicating an active speech-synthesis
 * utterance. Inherits `currentColor` so it picks up the surrounding
 * text colour - place inside a primary-coloured Button to match the
 * "speaking" state.
 */
export function SpeakingWaves({ className }: { className?: string }) {
  return (
    <span className={cn('bk-wave', className)} aria-hidden>
      <span />
      <span />
      <span />
      <span />
    </span>
  )
}
